import { render, staticRenderFns } from "./TreasuryDetailsCard.vue?vue&type=template&id=9856ec38&"
import script from "./TreasuryDetailsCard.vue?vue&type=script&lang=js&"
export * from "./TreasuryDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports